import React from "react";
import {
  decorateComponentWithProps,
  PLUGIN_TOOLBAR_BUTTON_ID
} from "./../editor-common";
import { getVisibleOnlyOnDesktopResolver } from "./../plugin-commons";
import { handleFileUpload } from ".//handle-file-upload";
import {
  AlignmentPanel,
  NodeAlignmentButton,
  NodeSizeButton,
  SizePanel
} from "./../toolbars-ui";
import { FILE_BUTTONS } from "./consts";
const getToolbarButtons = (config, services) => {
  const {
    context: { isMobile }
  } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: ["SMALL", "CONTENT"]
        }),
        id: FILE_BUTTONS.size
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeSizeButton, { id: FILE_BUTTONS.size, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: FILE_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: FILE_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      tooltip: "FileUploadReplaceButton_tooltip",
      command: ({ attributes: { selectedNode }, publicCommands }) => {
        handleFileUpload({ config, services, publicCommands, nodeId: selectedNode.attrs.id });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
